export const SquaredBackground = () => {
  return (
    <svg
      className="absolute -z-10 h-full w-full stroke-slate-300 dark:stroke-slate-800 mask-[radial-gradient(100%_100%_at_top_right,white,transparent)]"
      aria-hidden="true"
    >
      <defs>
        <pattern
          id="83fd4e5a-9d52-42fc-97b6-718e5d7ee527"
          width={100}
          height={100}
          x="50%"
          y={-1}
          patternUnits="userSpaceOnUse"
        >
          <path d="M50 100V.5M.5 .5H100" fill="none"></path>
        </pattern>
      </defs>
      <svg x="50%" y={-1} className="overflow-visible fill-slate-200 dark:fill-slate-800">
        <path
          d="M-50.5 0h101v101h-101Z M349.5 0h101v101h-101Z M249.5 200h101v101h-101Z M-150.5 300h101v101h-101Z"
          strokeWidth={0}
        />
      </svg>
      <rect
        width="100%"
        height="100%"
        strokeWidth={0}
        fill="url(#83fd4e5a-9d52-42fc-97b6-718e5d7ee527)"
      />
    </svg>
  );
};
